export const getOpenInNewProps = (openInNew) => {
	return openInNew
		? { target: "_blank", rel: "noopener noreferrer" }
		: undefined;
};
